(function($, window) {
  'use strict';
  var Pexeso;
  Pexeso = (function() {
    // Define the plugin class
    class Pexeso {
      constructor(el, options) {
        var self;
        this.onResize = this.onResize.bind(this);
        this.playPieceSoundOnClick = this.playPieceSoundOnClick.bind(this);
        this.pieceClicked = this.pieceClicked.bind(this);
        this.debug("construct");
        this.options = options;
        self = this;
        this.$el = $(el);
        if (options.data === void 0) {
          throw "parametr data je povinny";
        }
        if (options.backPieceUrl === void 0) {
          throw "parametr backPieceUrl je povinny";
        }
        $.when(this._loadPieces()).then(function() {
          return self.init();
        });
      }

      debug(msg) {
        if (this.options.debug) {
          return console.log(msg);
        }
      }

      _createBoard() {
        this.debug("_createBoard");
        return $.each(self.rawPieces, (key, val) => {
          return this.pieces.push({
            key: key,
            image: val.image,
            audio: val.audio
          });
        });
      }

      _createPairs() {
        this.debug("_createPairs");
        return this.pieces.push(...this.pieces);
      }

      init() {
        this.debug("init");
        this.blocked = true;
        this.debug(`blocked = ${this.blocked}`);
        this._createBoard();
        this._createPairs();
        this._shufflePieces();
        this._initAudioPieces();
        $("html").css("overflow", "hidden");
        this._createDOMPieces();
        this._renderPieces();
        this.initPauseTimer();
        $(window).resize(this.onResize);
        return $.when(this.options.onLoad()).then(() => {
          this.debug("@options.onLoad finished, starting timer");
          return setTimeout(() => {
            this.debug("timer ended, blocked = false");
            $("li.piece").flip(true);
            return this.blocked = false;
          }, 3000);
        });
      }

      _loadPieces() {
        this.debug("_loadPieces");
        return $.ajax({
          url: this.options.data,
          type: "json",
          success: (data) => {
            self.rawPieces = data.pieces;
            self.pexesoOptions = data.pexeso;
            return this.type = data.pexeso.type;
          }
        });
      }

      onFirstclick() {
        return $.ajax({
          url: this.options.startTimerUrl,
          type: "GET"
        });
      }

      stopTimer(redirect = null) {
        return $.ajax({
          url: this.options.stopTimerUrl,
          type: "GET",
          data: {
            points: this.points
          },
          success: function() {
            if (redirect !== null) {
              return location.href = redirect;
            }
          }
        });
      }

      _shufflePieces() {
        var i, j, results, t;
        this.debug("_shufflePieces");
        i = this.pieces.length;
        results = [];
        while (--i > 0) {
          j = ~~(Math.random() * (i + 1));
          t = this.pieces[j];
          this.pieces[j] = this.pieces[i];
          results.push(this.pieces[i] = t);
        }
        return results;
      }

      _initAudioPieces() {
        var k, len1, piece, ref, sounds;
        sounds = [];
        ref = this.pieces;
        for (k = 0, len1 = ref.length; k < len1; k++) {
          piece = ref[k];
          if (piece.audio) {
            sounds.push({
              name: piece.key,
              multiplay: true
            });
          }
        }
        return $.ionSound({
          sounds: sounds,
          volume: 0.5,
          path: this.options.audioPath,
          preload: true
        });
      }

      _createDOMPieces() {
        var $pieceElem, k, len1, piece, ref, results;
        ref = this.pieces;
        results = [];
        for (k = 0, len1 = ref.length; k < len1; k++) {
          piece = ref[k];
          $pieceElem = $("<li></li>").addClass("piece flipped").attr("data-key", piece.key).attr("data-image", piece.image).click(this.options.onPieceClick).click(this.pieceClicked).click(this.playPieceSoundOnClick).on('flip:done', this.flipDone);
          $("<div></div>").css("background-image", "url(/uploads/original/" + piece.image + ")").addClass("front").appendTo($pieceElem);
          $("<div></div>").css("background-image", "url(/uploads/original/" + this.options.backPieceUrl + ")").addClass("back").appendTo($pieceElem);
          results.push(this.DOMPieces.push($pieceElem));
        }
        return results;
      }

      _getClosestSquared(num) {
        if (Math.sqrt(num) % 1 !== 0) {
          return num;
        } else {
          return this._getClosestSquared(num + 1);
        }
      }

      _getSizes() {
        var changes, height, len, lenSqrt, margin, rowCount, rows, sizes, smallerSizeToScaleFor, tmpWidth, wastedSpace, width, wrapperWidth;
        if (!changes) {
          changes = {};
        }
        this.debug("creating DOM");
        console.log($("nav#top").outerHeight());
        height = 0;
        if ($(window).height() < 500) {
          // for too small screens use all height we can
          $("html").css("overflow", "auto");
          height = this.$el.height();
        } else {
          $("html").css("overflow", "hidden");
          height = $(window).height() - 30 - $("nav#top").outerHeight();
        }
        sizes = {
          "width": this.$el.width(),
          "height": height,
          "surface": this.$el.width() * this.$el.height()
        };
        len = this._getClosestSquared(this.pieces.length);
        lenSqrt = Math.sqrt(len);
        rows = lenSqrt;
        smallerSizeToScaleFor = sizes.height < sizes.width ? sizes.height : sizes.width;
        wrapperWidth = Math.ceil(smallerSizeToScaleFor / Math.ceil(len / rows));
        margin = wrapperWidth * 0.05;
        width = wrapperWidth - margin;
        rowCount = Math.floor(smallerSizeToScaleFor / width);
        tmpWidth = rowCount * width;
        wastedSpace = smallerSizeToScaleFor - tmpWidth;
        margin = Math.floor(wastedSpace / (rowCount * 2));
        return {
          wrapperWidth: wrapperWidth,
          margin: margin,
          width: width,
          rowCount: rowCount,
          tmpWidth: tmpWidth,
          wastedSpace: wastedSpace
        };
      }

      resizeBoardToFit() {
        var $piece, k, len1, ref, results, sizes;
        sizes = this._getSizes();
        ref = this.DOMPieces;
        results = [];
        for (k = 0, len1 = ref.length; k < len1; k++) {
          $piece = ref[k];
          results.push($piece.css({
            width: sizes.width,
            height: sizes.width,
            "margin": sizes.margin
          }));
        }
        return results;
      }

      onResize() {
        return this.resizeBoardToFit();
      }

      playPieceSoundOnClick(e) {
        var $el;
        $el = $(e.currentTarget);
        return this._playElemSound($el);
      }

      _playElemSound($el) {
        var id;
        id = $el.data("key");
        if (this.type === "voice") {
          return $.ionSound.play(id);
        }
      }

      _renderPieces() {
        var k, len1, piece, ref;
        this.debug("rendering DOM");
        ref = this.DOMPieces;
        for (k = 0, len1 = ref.length; k < len1; k++) {
          piece = ref[k];
          this.$el.append(piece);
          piece.width(piece.height());
        }
        return this.resizeBoardToFit();
      }

      pieceClicked(e) {
        this.debug(`pieceClicked, blocked = ${this.blocked}`);
        if (this.isFirstClick) {
          this.timer = 0;
          this.startTimer();
          this.onFirstclick();
          this.isFirstClick = false;
        }
        this.options.onClick();
        if (this.blocked) {
          this.debug("blocked, returning");
          e.preventDefault();
          return false;
        } else {
          // clicked the same piece
          if (this.currentlyFlipped && ($(e.target).parent("li").index() === this.currentlyFlipped.index())) {
            e.preventDefault();
            return false;
          }
          return this._checkPiecesMatch($(e.target).parent("li"));
        }
      }

      _checkPiecesMatch($current) {
        var key;
        key = $current.attr("data-key");
        $current.flip(false);
        if (!this.currentlyFlipped) {
          this.currentlyFlipped = $current;
          this.blocked = false;
          return false;
        }
        this.currentlyFlipped.flip(false);
        if (key === this.currentlyFlipped.attr("data-key")) {
          return this.piecesMatch($current);
        } else {
          return this.piecesDontMatch($current);
        }
      }

      piecesMatch($current) {
        this.debug("piecesMatch");
        this.currentlyFlipped.unbind("click").addClass("matched");
        $current.unbind("click").addClass("matched");
        $current.delay(600).animate({
          opacity: 0
        }, 600);
        this.currentlyFlipped.delay(600).animate({
          opacity: 0
        }, 600);
        this.currentlyFlipped = null;
        this.matchedCount += 2;
        setTimeout(() => {
          return this._playElemSound($current);
        }, 1000);
        this.givePoints();
        return this.checkWin();
      }

      piecesDontMatch($current) {
        this.debug("piecesNoMatch, blocked = true");
        this.blocked = true;
        if (this.type !== "time") {
          this.points--;
          this.refreshPoints();
        }
        return setTimeout(() => {
          this.debug("piecesNoMatch flippedBack, blocked = false");
          this.currentlyFlipped.flip(true);
          $current.flip(true);
          this.blocked = false;
          return this.currentlyFlipped = null;
        }, 1000);
      }

      _calculateSizes() {
        return {
          sizes: {
            width: this.$el.width,
            height: this.$el.height
          }
        };
      }

      flipDone(e) {
        return $(e.target).toggleClass("flipped");
      }

      checkWin() {
        // has won?
        if (this.DOMPieces.length === this.matchedCount) {
          this.clearTimer();
          return this.stopTimer(this.options.victoryPage);
        }
      }

      startTimer() {
        this.debug("startTimer");
        this.clearTimer();
        $("#navigation_pause").slideDown();
        return this.timerInterval = setInterval(() => {
          if (!this.isFreezedTimer) {
            this.timer++;
            this.timeSpent++;
            if (this.type === "time") {
              return this.renderTimeSpent();
            }
          }
        //@debug("timer: #{@timer}")
        }, 1000);
      }

      clearTimer() {
        return clearInterval(this.timerInterval);
      }

      initPauseTimer() {
        this.debug("initPauseTimer");
        return $("#navigation_pause").click((e) => {
          var $button;
          this.debug("navigation_pause click");
          this.debug($(e.target));
          this.isFreezedTimer = !this.isFreezedTimer;
          $button = $(e.target);
          $button.toggleClass("navigation_play");
          $button.toggleClass("navigation_pause");
          return $("#overlay").fadeToggle();
        });
      }

      givePoints() {
        this.debug("givePoints");
        if (this.type === "time") {

        //  nothing to do
        } else if (this.type === "sound") {
          this.points += 10;
          return this.refreshPoints();
        } else {
          this.points += 10;
          return this.refreshPoints();
        }
      }

      refreshPoints() {
        return $("#points #value").text(this.points + " bodů");
      }

      renderTimeSpent() {
        var minutes, seconds;
        //@debug "renderTimeSpent"
        minutes = Math.floor(this.timeSpent / 60);
        seconds = Math.floor(this.timeSpent - (minutes * 60));
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        return $("#points #value").text(`${minutes}:${seconds}`);
      }

    };

    Pexeso.prototype.$el = false;

    Pexeso.prototype.rawPieces = {};

    Pexeso.prototype.pieces = [];

    Pexeso.prototype.DOMPieces = [];

    Pexeso.prototype.timer = 0;

    Pexeso.prototype.timerInterval = null;

    Pexeso.prototype.timeSpent = 0;

    Pexeso.prototype.points = 0;

    Pexeso.prototype.matchedCount = 0;

    Pexeso.prototype.isFreezedTimer = false;

    Pexeso.prototype.currentlyFlipped = null;

    Pexeso.prototype.block = false;

    Pexeso.prototype.pexesoOptions = [];

    Pexeso.prototype.options = {};

    Pexeso.prototype.timeofLastMatch = 0;

    Pexeso.prototype.type = null;

    Pexeso.prototype.isFirstClick = true;

    Pexeso.prototype.ion = null;

    return Pexeso;

  }).call(this);
  // Define the plugin
  return $.fn.extend({
    Pexeso: function(option, ...args) {
      return this.each(function() {
        var $this, data;
        $this = $(this);
        data = $this.data('Pexeso');
        if (!data) {
          $this.data('Pexeso', (data = new Pexeso(this, option)));
        }
        if (typeof option === 'string') {
          return data[option].apply(data, args);
        }
      });
    }
  });
})(window.jQuery, window);
